import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Lock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      sessionStorage.setItem("gyc-admin-token", data.token);
      onLogin(data.token);
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Password non corretta");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="mx-auto max-w-sm rounded-3xl bg-white border border-border p-8 shadow-sm space-y-4" data-testid="admin-login-form">
      <div className="flex items-center gap-2 text-pine"><Lock size={18} /><span className="font-serif text-xl">Area di Giada</span></div>
      <input
        type="password"
        data-testid="admin-password-input"
        required
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Password"
        className="w-full rounded-xl border border-border bg-white px-4 py-3 text-sm text-ink outline-none focus:border-pine focus:ring-2 focus:ring-pine/15"
      />
      <button
        type="submit"
        data-testid="admin-login-submit"
        disabled={loading}
        className="w-full rounded-full bg-pine px-6 py-3 text-sm font-semibold text-linen transition-colors hover:bg-pine-dark disabled:opacity-50"
      >
        {loading ? "Accesso..." : "Entra"}
      </button>
    </form>
  );
};
